import Header from '@components/Header';
import colors from '@constants/colors';
import { Link } from '@stackflow/link';
import { useTranslation } from 'react-i18next';

function StampHeader() {
    const { t } = useTranslation('stamp');
    return (
        <Header title={t('title')}
            backgroundColor={colors.gray1}
            trailing={<Link activityName='StampSortBottomSheet'
                activityParams={{}}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M7 12L7 13L9 13L9 12L8 12L7 12ZM9 3C9 2.44771 8.55228 2 8 2C7.44771 2 7 2.44771 7 3L8 3L9 3ZM8 12L9 12L9 3L8 3L7 3L7 12L8 12Z" fill="#504A46"/>
                    <path d="M9 16L9 15L7 15L7 16L8 16L9 16ZM7 20C7 20.5523 7.44772 21 8 21C8.55228 21 9 20.5523 9 20L8 20L7 20ZM8 16L7 16L7 20L8 20L9 20L9 16L8 16Z" fill="#504A46"/>
                    <path d="M17 11L17 10L15 10L15 11L16 11L17 11ZM15 20C15 20.5523 15.4477 21 16 21C16.5523 21 17 20.5523 17 20L16 20L15 20ZM16 11L15 11L15 20L16 20L17 20L17 11L16 11Z" fill="#504A46"/>
                    <path d="M15 7L15 8L17 8L17 7L16 7L15 7ZM17 3C17 2.44772 16.5523 2 16 2C15.4477 2 15 2.44772 15 3L16 3L17 3ZM16 7L17 7L17 3L16 3L15 3L15 7L16 7Z" fill="#504A46"/>
                    <circle cx="8" cy="14" r="2" stroke="#504A46" stroke-width="2"/>
                    <circle cx="16" cy="9" r="2" stroke="#504A46" stroke-width="2"/>
                </svg>
            </Link>
            }
        />
    );
}

export default StampHeader;
